const ORDERS_URL = process.env.VUE_APP_API_URL.concat(
  "/rest/V1/b2b-order/post"
);
import { request } from "../services/request";

function mapLinesToProducts(line, currencyRatio) {
  return {
    product: {
      ...line.product,
    },
    quantity: line.quantity,
    quantityToBlocked: line.quantityToBlocked,
    quantityToTransport: line.quantityToTransport,
    etollDateFrom: line.etollDateFrom ? line.etollDateFrom : null,
    etollEmai: line.etollEmai ? line.etollEmai : null,
    basePrice: line.basePrice / currencyRatio,
    edit: line.edit ? line.edit : false,
    status: line.status ? line.status : "O",
    baseLine: line.baseLine ? line.baseLine : "",
    sample: line.sample ? line.sample : "N",
  };
}
export default {
  namespaced: true,
  state: {
    offlineOrders: [],
  },
  actions: {
    storeOrder(context, order) {
      const userData = context.rootState.auth.user;
      let orderData = {
        shippingOptions: order.shipping,
        currency: context.rootState.currency.currency,
        comment: order.comment,
        customer: order.customer,
        header: {
          cardCode: order.customer.cardCode,
          status: order.status,
          type: order.type,
          requiredTransport: order.requiredTransport,
          referenceNumber: order.referenceNumber,
          specialOrder: order.specialOrder,
          invoiceForTransport: order.invoiceForTransport,
          payment: order.payment,
          proposalTime: order.proposalTime,
          salesOrderReal: order.salesOrderReal,
          docToSend: order.docToSend,
          shippingOptionsValue: order.shippingValue,
          incrementId: order.increment_id ? order.increment_id : null,
          docEntry: order.docEntry ? order.docEntry : null,
          language: context.rootState.auth.language,
          prepayment: order.prepayment,
          shippingCity: order.shippingCity,
          docRate: order.docRate ? order.docRate : null,
          specialAddressForm: order.specialAddressForm ?? null,
          addressForm: order.addressForm,
        },
        products: order.lines.map((product) =>
          mapLinesToProducts(product, context.rootState.currency.ratio)
        ),
      };
      console.log(orderData);
      //   return true;
      userData.availableCountries = [];
      if (navigator.onLine) {
        let options = {
          data: {
            order: orderData,
            user: userData,
          },
          url: ORDERS_URL,
        };
        return request("post", options, "createOrderService");
      } else {
        // Deep clone to avoid mutations
        context.commit("addOfflineOrder", {
          ...order,
          lines: [...order.lines],
        });
      }
    },
    launchOfflineOrders({ commit, state, dispatch }) {
      state.offlineOrders.forEach(async (order) => {
        await dispatch("storeOrder", order);
        commit("removeOfflineOrder", order);
      });
    },
  },
  mutations: {
    addOfflineOrder(state, order) {
      state.offlineOrders.push(order);
    },
    removeOfflineOrder(state, order) {
      state.offlineOrders.splice(state.offlineOrders.indexOf(order));
    },
  },
};
